const cropToNumberOfItems = ({ value, numberOfItems }) =>
  value > numberOfItems ? numberOfItems : value;

export const colWidthBreakpoints = ({
  numberOfItems,
}: {
  numberOfItems: number;
}) => ({
  s: 1,
  m: 1 / cropToNumberOfItems({ value: 2, numberOfItems }),
  l: 1 / cropToNumberOfItems({ value: 3, numberOfItems }),
  xl: 1 / cropToNumberOfItems({ value: numberOfItems, numberOfItems }),
});

export const perPageBreakpoints = ({
  numberOfItems,
}: {
  numberOfItems: number;
}) => ({
  s: cropToNumberOfItems({ value: 1, numberOfItems }),
  m: cropToNumberOfItems({ value: 2, numberOfItems }),
  l: cropToNumberOfItems({ value: 3, numberOfItems }),
  xl: numberOfItems,
});
